import React from 'react'
import HeaderWidgetComponentTransaparent from './../../../widgets/HeaderWidget/HeaderWidgetComponentTransparent';

import {
    BannerContainerFluid,OverlayContainerFluid,HeadingText
} from './BlogBannerComponent.style';
function BlogBannerComponent() {
  return (
    <div>
        <BannerContainerFluid>
            <OverlayContainerFluid>
                <HeaderWidgetComponentTransaparent/>
                <div className='row mt-100'>
                    <div className='col s12 center'>
                        <HeadingText>
                            Blog
                        </HeadingText>
                    </div>
                </div>
            </OverlayContainerFluid>
        </BannerContainerFluid>

    </div>
  )
}

export default BlogBannerComponent